import { getYear, parseISO } from "date-fns";
import { ComparisonChartData } from "@components";
import type { DateValuePair } from "@rentablo/api/apiv1";

export const mergeHistoricQuotes = (
  chartData?: ComparisonChartData[],
  historicQuotes?: DateValuePair[]
) =>
  chartData?.map((data) => {
    const quote = historicQuotes?.find(
      ({ date }) => date && getYear(parseISO(date)) === data.year
    );
    return { ...data, quote: quote?.value };
  });
